import { all, takeEvery, put, call } from 'redux-saga/effects';
import actions from "./actions";
import {getConsentTypeApi, getConsentTypesApi} from "../../services/consent_type.service"
import { AxiosResponse } from 'axios';
import logError from "../../utils/logError";
export function* GET_ALL_CONSENT_TYPES() {
    try {
        const response: AxiosResponse<any> = yield call(getConsentTypesApi);
        if (response.data) {
            yield put({
                type: actions.SET_DATA,
                payload: response.data
            })
        }
    } catch (e) { logError("redux/consent_types/sagas/GET_ALL_CONSENT_TYPES", e); }
}

export function* GET_CONSENT(action:{payload: string, type: any}) {
    const consentUuid = action.payload;
    if (consentUuid){
    try {
        const response: AxiosResponse<any> = yield call(
          getConsentTypeApi,
          consentUuid
        );
        if (response.data) {
            yield put({
                type: actions.SET_CONSENT,
                payload: response.data
            })
        }
    } catch (e) { logError("redux/consent_types/sagas/GET_CONSENT", e); }}
}


export default function* rootSaga() {
    yield all([
        takeEvery(actions.GET_DATA, GET_ALL_CONSENT_TYPES),
        takeEvery(actions.GET_CONSENT, GET_CONSENT),
    ])
}
